module.exports = __webpack_public_path__ + "media/Video 70.b6701a03.mp4";